import { Injectable } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import ceil from 'lodash-es/ceil';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import { OrdersListService } from '../../order-list-components/order-list.service';
import { SALES_RETURN_LIST_EXPORT_ID, SALES_RETURN_LIST_TITLE } from '../../quotation/exports/quotation-list.constants';
import { ReturnListExcelExportProcessor } from './return-list.excel';

@Injectable()
export class SalesReturnListExport {
    constructor(
        private exportService: ExportService,
        private decimalPipe: DecimalPipe,
        private ordersListService: OrdersListService,
    ) {}

    export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
        const totalPages = ceil(totalItems / pageSize) + 1;
        this.exportService.task({
        id: SALES_RETURN_LIST_EXPORT_ID,
        title: SALES_RETURN_LIST_TITLE,
        format,
        iterations: range === ExportRange.AllPages ? totalPages : 1,
        processor: format === ExportFileFormat.JSON
            ? new ReturnListExcelExportProcessor(this.decimalPipe)
            : new ReturnListExcelExportProcessor(this.decimalPipe),
        next: (ctx: ExportContext) => {
            const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
            this.ordersListService.findByFilter(
            buildQuery(
                seed(this.ordersListService.currentFilter), page(currentPage, pageSize)
            ),
            this.ordersListService.currentFilterData,
            { contextHeader: 'export' },
            ).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
            get(response, 'data.data', []).forEach((item) => { ctx.add(item); });
            ctx.next();
            });
        },
        }).start();
    }

    canStartTask() {
        if (this.exportService.taskIsActive(SALES_RETURN_LIST_EXPORT_ID)) {
        this.exportService.setVisible(true);
        return false;
        }
        return true;
    }
}
